module.exports = __webpack_public_path__ + "img/down09.48f77285.png";